import type { Commitment, CommitmentType, CostpointType } from '@finapp/types';
import { API_BASE_URL, ApiError, fetchWithAuth } from '../config/api';

export class CommitmentsApiError extends ApiError {
  constructor(message: string, status?: number, details?: unknown) {
    super(message, status, details);
    this.name = 'CommitmentsApiError';
  }
}

export interface CommitmentFilter {
  budgetPeriodId?: number;
  costpoint?: CostpointType;
}

export interface CreateCommitmentInput {
  budget_period_id: number;
  costpoint: CostpointType;
  type: CommitmentType;
  amount: number;
  description: string;
}

export interface UpdateCommitmentInput {
  description?: string;
  amount?: number;
}

// Mirrors forecastApi.ts's convention for building/calling endpoints under api/v1.
export const commitmentsApi = {
  async list(filter: CommitmentFilter = {}): Promise<Commitment[]> {
    const queryParams = new URLSearchParams();
    if (filter.budgetPeriodId !== undefined) {
      queryParams.set('budgetPeriodId', filter.budgetPeriodId.toString());
    }
    if (filter.costpoint) {
      queryParams.set('costpoint', filter.costpoint);
    }
    const qs = queryParams.toString();
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/commitments${qs ? `?${qs}` : ''}`);
    return (await response.json()) as Commitment[];
  },

  async create(input: CreateCommitmentInput): Promise<Commitment> {
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/commitments`, {
      method: 'POST',
      body: JSON.stringify(input),
    });
    return (await response.json()) as Commitment;
  },

  async update(id: number, input: UpdateCommitmentInput): Promise<Commitment> {
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/commitments/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    });
    return (await response.json()) as Commitment;
  },

  async remove(id: number): Promise<void> {
    await fetchWithAuth(`${API_BASE_URL}/api/v1/commitments/${id}`, { method: 'DELETE' });
  },
};
